"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(function () {
  if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
    // check if cookie consent should be set automatically
    if (document.getElementById('content').classList.contains('analytics_enabled')) {
      var oneYearFromNow = new Date();
      oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
      var oneYearFromNowUtc = oneYearFromNow.toUTCString();
      document.cookie = 'cfcookiemanager=1; expires=' + oneYearFromNowUtc + '; path=/';
    }
    if (!(document.cookie.indexOf("cfcookiemanager") >= 0)) {
      // set cookie
      var _oneYearFromNow = new Date();
      _oneYearFromNow.setFullYear(_oneYearFromNow.getFullYear() + 1);
      var _oneYearFromNowUtc = _oneYearFromNow.toUTCString();
      document.cookie = 'cf_cookie={"categories":["cfcookiemanager"],"level":["cfcookiemanager"],"revision":1,"data":null,"rfc_cookie":false,"consent_date":"' + new Date().toISOString() + '","consent_uuid":"c12c1848-11d8-4145-8e13-a886de9ed18e","last_consent_update":"' + new Date().toISOString() + '"};secure;SameSite=Lax;Domain=.' + window.location.hostname + ';expires=' + _oneYearFromNowUtc + '; path=/';
      document.addEventListener('DOMContentLoaded', function () {
        window.cc.accept(['cfcookiemanager']);
      });
    }
    document.addEventListener('DOMContentLoaded', function () {
      var consentButton = document.querySelector('.c-bn.c_settings');
      if (consentButton) {
        consentButton.click();
        document.getElementById('cc--main').addEventListener("click", function (e) {
          if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
            if (e.key === 'Escape' || e.keyCode === 27) {
              document.getElementById('c-t-bn').click();
            }
            if (e.target.id === 'c-s-in' || e.target.id === 'cs') {
              document.getElementById('c-t-bn').click();
            }
          }
        });
        if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
          var _document$getElementB;
          (_document$getElementB = document.getElementById('s-c-bn')) === null || _document$getElementB === void 0 || _document$getElementB.classList.add("d-none");
        }
        document.querySelectorAll('#s-bns .c-bn').forEach(function (button) {
          button.addEventListener("click", function (e) {
            var _document$getElementB2;
            (_document$getElementB2 = document.getElementById('s-c-bn')) === null || _document$getElementB2 === void 0 || _document$getElementB2.classList.remove("d-none");
          });
        });
        document.addEventListener('keydown', function (e) {
          if (!(document.cookie.indexOf("cf_cookie") >= 0)) {
            if (e.key === 'Escape' || e.keyCode === 27) {
              document.getElementById('c-t-bn').click();
            }
            if (e.target.id === 'c-s-in' || e.target.id === 'cs') {
              document.getElementById('c-t-bn').click();
            }
          }
        });
        removeAriaHidden();
      }
      document.querySelectorAll('.cookie-item').forEach(function (cookieItem) {
        // add tabindex = 0 to make it focusable
        cookieItem.setAttribute('tabindex', '0');
        cookieItem.setAttribute('role', 'button');
        cookieItem.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.keyCode === 13 || e.key === " " || e.code === "Space" || e.keyCode === 32) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            // get next sibling of cookieItem
            var nextSibling = cookieItem.nextElementSibling;
            nextSibling.classList.toggle('cookie-description-active');
          }
        });
      });
    });
  }
})();
function removeAriaHidden() {
  document.querySelectorAll('.desc,.cfwrapper').forEach(function (desc) {
    if (desc.hasAttributes('aria-hidden')) {
      desc.removeAttribute('aria-hidden');
    }
    desc.addEventListener('click', function (e) {
      if (this.hasAttributes('aria-hidden')) {
        this.removeAttribute('aria-hidden');
      }
    });
  });
  document.querySelectorAll('.block-section .b-tl').forEach(function (button) {
    button.addEventListener('click', function (e) {
      var element = this.parentElement.nextSibling;
      if (element.hasAttributes('aria-hidden')) {
        element.removeAttribute('aria-hidden');
      }
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  var _document$querySelect;
  removeAriaHidden();
  (_document$querySelect = document.querySelectorAll('.cc-s-btn')[0]) === null || _document$querySelect === void 0 || _document$querySelect.addEventListener('click', function (e) {
    setTimeout(function () {
      removeAriaHidden();
    }, 200);
  });
  var acceptServiceButton = document.querySelectorAll('.c-la-b, .c-l-b');
  acceptServiceButton.forEach(function (button) {
    button.addEventListener('click', function (e) {
      // find parent with class
      var service = button.closest('[data-service]').getAttribute('data-service');
      if (service) {
        var accepted_categories = window.cc.getUserPreferences().accepted_categories;
        if (accepted_categories.length > 0) {
          window.cc.accept([].concat(_toConsumableArray(accepted_categories), [service]));
        } else {
          window.cc.accept([service]);
        }
      }
    });
  });
  var providerLinks = document.querySelectorAll('tr.cookie-item > td > a');
  setTimeout(function () {
    providerLinks.forEach(function (link) {
      if (link.innerHTML === 'Provider') {
        link.remove();
      }
    });
  }, 1500);
  var tableHeaders = document.querySelectorAll('.cf-category-wrapper table tr > th');
  tableHeaders.forEach(function (header) {
    if (header.innerHTML === '') {
      header.remove();
    }
  });
});